import { Wrapper } from "@googlemaps/react-wrapper";
import { PropsWithChildren } from "react";

type Props = PropsWithChildren & {
  apiKey: string
}

const GoogleMapsWrapper = ({apiKey, children}: Props) => {
  return <Wrapper apiKey={apiKey} libraries={["marker", "places"]}>
    {children}
  </Wrapper>
}

export default GoogleMapsWrapper
